/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExchangeCodeForTokensRequest
 */
export interface ExchangeCodeForTokensRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ExchangeCodeForTokensRequest
     */
    readonly $schema?: string;
    /**
     * Code
     * @type {string}
     * @memberof ExchangeCodeForTokensRequest
     */
    code: string;
}

/**
 * Check if a given object implements the ExchangeCodeForTokensRequest interface.
 */
export function instanceOfExchangeCodeForTokensRequest(value: object): value is ExchangeCodeForTokensRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function ExchangeCodeForTokensRequestFromJSON(json: any): ExchangeCodeForTokensRequest {
    return ExchangeCodeForTokensRequestFromJSONTyped(json, false);
}

export function ExchangeCodeForTokensRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeCodeForTokensRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'code': json['code'],
    };
}

export function ExchangeCodeForTokensRequestToJSON(json: any): ExchangeCodeForTokensRequest {
    return ExchangeCodeForTokensRequestToJSONTyped(json, false);
}

export function ExchangeCodeForTokensRequestToJSONTyped(value?: Omit<ExchangeCodeForTokensRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

